import React from 'react';
import Button from 'react-bootstrap/Button';
import {SchemaProps} from "../../../types/Schema";
import IconButton from "../../buttons/icon-button/IconButton";
import {DialogService} from "../../../common/Dialog";
import {SchemaContext} from "../context/SchemaContext";

type ValidateDataActionProps = {
  schema?: SchemaProps;
  schemaId?: string;
  standardButton?: boolean;
  disabled?: boolean;
  forbidden?: boolean;
};

/**
 * Implementation of a data validation start/stop toggle button.
 */
class ValidateDataAction extends React.Component<ValidateDataActionProps> {

  static contextType = SchemaContext;

  schemaId: string;

  constructor(props: ValidateDataActionProps) {
    super(props);
    this.schemaId = this.props.schemaId || this.props.schema?.id || '';
  }

  onValidationStart = (): void => {
    this.context.validateData(this.schemaId);
  }

  onValidationStop = (): void => {
    DialogService.confirm({
      message: 'Data validation is in progress. Do you want to stop it?',
      onConfirm: this.stopDataValidation
    });
  }

  stopDataValidation = (): void => {
    this.context.stopDataValidation(this.schemaId);
  }

  render() {
    const {isDataValidationRunning} = this.context;
    let title = 'Run data validation for this schema';
    let label = 'Validate Schema against Data';
    let clickHandler = this.onValidationStart;
    if (isDataValidationRunning) {
      title = 'Stop Data Validation';
      label = 'Stop Data Validation';
      clickHandler = this.onValidationStop;
    }

    const isDisabled = this.props.forbidden || this.props.disabled;

    return (
      <>
        {
          this.props.standardButton &&
          <Button className="ValidateDataAction"
                  onClick={clickHandler}
                  title={title}
                  disabled={isDisabled}>
            {label}
          </Button>
        }
        {
          !this.props.standardButton &&
          <IconButton icon="trash-alt" onClick={clickHandler}
                      title={title}
                      disabled={isDisabled}
                      className="ValidateDataAction"/>
        }
      </>
    );
  }
}

export default ValidateDataAction;
